import * as React from 'react';
import { FluidPanel, ValidationProps } from 'ui';
import styles from './loss-potential-evaluation-footer.scss';

export interface LossPotentialEvaluationFooterProps {
  componentId: any;
  validation: ValidationProps;
  showDetails: boolean;
  children: any;
}

export const LossPotentialEvaluationFooter = (props: LossPotentialEvaluationFooterProps) => {

  const { showDetails = true, validation } = props;

  const validationStyle = validation ? styles.hasValidation : '';
  
  return (showDetails ? 
      
    <div className={`${styles.lossPotentialEvaluationFooter} ${validationStyle}`}>
      <FluidPanel {...props} className=''/></div>
    : null);
};
